import React, { Component } from 'react'
import '../styles/GlobalStyle.css'
import { db, firebase } from '../firebase/Firebase'
import ColType from '.././Types'
import { flattenDoc, linkAfterLogin } from '.././Util'
import SuperAdminHeader from './SuperAdminHeader'
import { Input, Layout, Button, Icon, Switch, Select, Row, Col } from 'antd'
//import { Document } from '../teacher/edvizv2/Edviz'
const Sider = Layout.Sider
const Content = Layout.Content

const TEST_DISTRICT_ID = '64bec570267c8bfeea81f9ea'

class SuperAdminDistrictUserRoles extends Component {
    state = {
        districtId: '5410a3828725bd2f0d00100d',
        district: null,
        districtUserRoles: {},
        endWeeks: [2, 3, 6, 9, 12, 15, 18, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39],
        districtUserRolesListener: null,
        districtUserRolesDocExists: false,
        superAdmindistrictUserRoles: {
            canRegen: {},
        },
        superAdmindistrictUserRolesListener: null,
        superAdmindistrictUserRolesDocExists: false,
        cleverId: '',
        additionalCode: '',
        userToken: '',
        users: [],
        usersDict: {},
        searchUserValue: '',
        searchUsers: [],
    }

    componentDidMount() {

    }

    changeRolesTo = (userIds, role) => {
        let updateObj = {};
        for (let i = 0; i < userIds.length; i++) {
            let userId = userIds[i];
            updateObj[userId] = role;
        }
        db.collection(ColType.districtUserRoles)
            .doc(this.state.districtId)
            .update(updateObj)
            .then(() => {
                console.log('Roles successfully updated!')
            })
            .catch((error) => {
                console.error('Error updating roles: ', error)
            });
    }

    getDistrictUserRoles = () => {
        if (!this.state.districtId) {
            return
        }

        db.collection(ColType.district)
            .doc(this.state.districtId)
            .get()
            .then((doc) => {
                let district = flattenDoc(doc)
                this.setState({ district: district })
            })

        console.log('districtId', this.state.districtId)

        db.collection(ColType.users)
            .where('districtId', '==', this.state.districtId)
            .where('accessLevel', 'in', ['teachers', 'instructionalFacilitators', 'admins'])
            .get()
            .then((querySnapshot) => {
                let users = []
                let usersDict = {}
                let admins = []
                let coaches = []
                let teachers = []
                querySnapshot.forEach((doc) => {
                    let user = flattenDoc(doc)
                    users.push(user)
                    usersDict[user.id] = user

                    if (user.accessLevel === 'admins') {
                        admins.push(user)
                    } else if (user.accessLevel === 'instructionalFacilitators') {
                        coaches.push(user)
                    } else if (user.accessLevel === 'teachers') {
                        teachers.push(user)
                    }
                });
                console.log('users', users, 'admins', admins, 'coaches', coaches, 'teachers', teachers)
                this.setState({ users: users, usersDict: usersDict })
            })

        if (this.state.districtUserRolesListener) {
            this.state.districtUserRolesListener()
        }
        let districtUserRolesListener = db.collection(ColType.districtUserRoles)
            .doc(this.state.districtId)
            .onSnapshot({ includeMetadataChanges: true }, (doc) => {
                // if from cache return, only want server updates
                if (doc.metadata.fromCache) {
                    return
                }
                if (doc.exists) {
                    let districtUserRoles = flattenDoc(doc)
                    console.log('districtUserRoles listener', districtUserRoles)
                    this.setState({
                        districtUserRoles: districtUserRoles,
                    })
                } else {
                    console.log('no district settings, creating initial document')
                    db.collection(ColType.districtUserRoles)
                        .doc(this.state.districtId)
                        .set({}, { merge: true })
                        .then(() => {
                            console.log('Initial Document successfully updated!')
                        })
                        .catch((error) => {
                            console.error('Initial Error updating document: ', error)
                        })
                }
            })

        this.setState({
            districtUserRolesListener: districtUserRolesListener,
        })
    }

    componentWillUnmount() {
        if (this.state.districtUserRolesListener) {
            this.state.districtUserRolesListener()
        }
    }

    sortUsers = (a, b) => {
        let userA = this.state.usersDict[a];
        let userB = this.state.usersDict[b];
        if (userA && userB) {
            let accessLevelA = userA.accessLevel;
            let accessLevelB = userB.accessLevel;
            if (accessLevelA !== accessLevelB) {
                if (accessLevelA === 'admins') {
                    return -1;
                }
                if (accessLevelB === 'admins') {
                    return 1;
                }
                if (accessLevelA === 'instructionalFacilitators') {
                    return -1;
                }
                if (accessLevelB === 'instructionalFacilitators') {
                    return 1;
                }
            }
            let nameA = (userA.firstName + ' ' + userA.lastName).toLowerCase();
            let nameB = (userB.firstName + ' ' + userB.lastName).toLowerCase();
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
        }
        return 0;
    };

    render() {
        return (
            <div>
                <SuperAdminHeader menuKey={'district-settings'} />
                <div>
                    <Sider
                        width={270}
                        style={{
                            overflow: 'auto', overflowX: 'hidden', height: 'calc(100% - 64px)',
                            position: 'fixed',
                            left: 0, borderRight: '1px solid #f1f1f1',
                            background: '#fff',
                        }}>
                        <div style={{ marginTop: 64 }}>
                            <div className='flex flex-v-center pl-2 pr-2'>
                                <Input placeholder='District Clever Id' size='large'
                                    value={this.state.districtId}
                                    onChange={(e) => {
                                        this.setState({ districtId: e.target.value })
                                    }}>
                                </Input>
                                <Button size='large' type='primary'
                                    className='br-50 ml-05 flex flex-v-center flex-h-center'
                                    style={{ width: 40, height: 40 }}
                                    onClick={(e) => {
                                        this.getDistrictUserRoles()
                                    }}
                                >
                                    <Icon type='search' />
                                </Button>
                            </div>
                            {this.state.district ?
                                <div className='mt-2 pl-2 pr-2 font-16'>
                                    <div className='font-bold'>
                                        {this.state.district.district}</div>
                                    <div className='mb-05'>District User Roles</div>
                                </div> : ''}
                        </div>
                    </Sider>
                    <Layout className="content" style={{ marginLeft: 270, marginTop: "32px", overflowX: 'initial' }}>
                        <Content
                            className={"layout-content background-fff p-3 pt-0 br-4 print-remove-padding print-remove-margin"}
                        >
                            <div>
                                <Row gutter={48} className='mt-50'>
                                    {/*<Button onClick={(e) => {
                                        this.changeRolesTo([], 'admins');
                                    }}>Change roles</Button>*/}
                                    <Col span={12}>
                                        <Input placeholder='Search Users' size='large'
                                            value={this.state.searchUserValue}
                                            onChange={(e) => {
                                                this.setState({ searchUserValue: e.target.value })
                                            }}>
                                        </Input>
                                        <div className='mt-2'>
                                            {this.state.users.filter((user) => {
                                                if (!this.state.searchUserValue || this.state.searchUserValue === '') {
                                                    return false;
                                                }
                                                let searchValue = this.state.searchUserValue.toLowerCase();
                                                if ((user.firstName + ' ' + user.lastName).toLowerCase().includes(searchValue)) {
                                                    return true;
                                                }
                                            }).map((user) => {
                                                return (
                                                    <div key={'add-' + user.id} className='mb-1 p-1 border br-4 hover-grey cursor-pointer'
                                                        title="Click to add to district user roles"
                                                        onClick={(e) => {
                                                            db.collection(ColType.districtUserRoles)
                                                                .doc(this.state.districtId)
                                                                .update({
                                                                    [user.id]: user.accessLevel
                                                                });
                                                        }}
                                                    >
                                                        <div className='font-16'>
                                                            <div className='font-bold'>
                                                                {user.firstName} {user.lastName}
                                                            </div>
                                                            <div>
                                                                {user.accessLevel} - {user.id}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </Col>
                                    <Col span={12}>
                                        <div>
                                            {Object.keys(this.state.districtUserRoles).length === 0 ?
                                                <div>No users with roles assigned</div> : ''}

                                            {Object.keys(this.state.districtUserRoles).sort(this.sortUsers).map((userId) => {
                                                let user = this.state.usersDict[userId];
                                                if (!user) {
                                                    return ''
                                                }
                                                // happens when removed for one render update
                                                if (typeof this.state.districtUserRoles[userId] !== 'string') {
                                                    return ''
                                                }
                                                return (
                                                    <div key={'role-' + userId} className='mb-1 p-1 border br-4 flex flex-v-center w-100'
                                                    >
                                                        <div className='w-100'>
                                                            <div className='flex flex-v-center w-100'>
                                                                <div>
                                                                    <div className='font-16 font-bold'>
                                                                        {user.firstName} {user.lastName}
                                                                    </div>
                                                                    <div>
                                                                        <Select value={this.state.districtUserRoles[userId]}
                                                                            onChange={(value) => {
                                                                                db.collection(ColType.districtUserRoles)
                                                                                    .doc(this.state.districtId)
                                                                                    .update({
                                                                                        [userId]: value
                                                                                    });
                                                                            }}
                                                                            style={{ width: 200 }}
                                                                        >
                                                                            <Select.Option value='teachers'>Teacher</Select.Option>
                                                                            <Select.Option value='instructionalFacilitators'>Instructional Facilitator</Select.Option>
                                                                            <Select.Option value='admins'>Admin</Select.Option>
                                                                        </Select>
                                                                        {' - '}{userId}
                                                                    </div>
                                                                </div>
                                                                <div className='ml-auto'>
                                                                    <Button type='default' size='small'
                                                                        onClick={(e) => {
                                                                            db.collection(ColType.districtUserRoles)
                                                                                .doc(this.state.districtId)
                                                                                .update({
                                                                                    [userId]: firebase.firestore.FieldValue.delete()
                                                                                });
                                                                        }}
                                                                    >Remove</Button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Content>
                    </Layout>
                </div>
            </div>
        )
    }
}

export default SuperAdminDistrictUserRoles